
import {
    getSalesAnalysisReport
} from "./api/exportapi"

import { downloadFile, openFile} from '@/utils/files'

class ExportDataService{
    async exportSalesAnalysisReport (type,year, month){
        
        var params = {year: year, month: month} 
        try {
            const file = await getSalesAnalysisReport(type, params)
            const fileName = `銷售月報表-` + year + `年` +  month + `月`
            const downloadFiles = {
                pdf: () => openFile(file, fileName, 'pdf'),
                excel: () => downloadFile(file, fileName, 'excel')
            }
            downloadFiles[type]()
            return file
        } catch (err) {
            return err
        }
    }
}

export default new ExportDataService();